import { NewButton, NewButtonVariant } from "@visiblethread/react-components";
import { Trash2 } from "lucide-react";
import { func, string } from "prop-types";

const RemoveButton = ({ onClick, "aria-label": ariaLabel }) => (
  <NewButton
    variant={NewButtonVariant.red}
    leftIcon={<Trash2 size={16} />}
    onClick={onClick}
    aria-label={ariaLabel}
    data-testid="disable-button"
  />
);

RemoveButton.propTypes = {
  onClick: func.isRequired,
  "aria-label": string,
};

export default RemoveButton;
